<!--  -->
<template>
    <div>
        <div class="banner">
            <div class="textbox">
                    <div class="banner-text1">联系我们</div>
                    <div class="banner-text2">共性中立 兼容互通 全国互认</div>
                </div>
        </div>

        <div class="box1">
            <div class="title"></div>
            <div class="content">
                <div class="infocard">
                    <div class="top">
                        <div class="top-text">客服咨询</div>
                    </div>
                    <div class="infobox">
                      <div>
                        <div style="display: flex;justify-content: space-between">
                        <div class="row" >
                            <img src="../assets/img/contactUs/ico-kf.png" alt="" class="ico1">
                            <span class="infotext1">&nbsp; 电话热线:</span>
                            <span class="infotext2">&nbsp;400 666 6011</span>

                        </div>
                        <div class="infotext2" style="float: right;">（周一 至 周日 8：30 - 21：00）</div>
                    </div>
                       
                      </div>
                    </div>
                </div>
                <div class="infocard">
                    <div class="top2">
                        <div class="top-text">技术支持</div>
                    </div>
                    <div class="infobox">
                      <div>
                        <!-- <div style="display: flex;justify-content: space-between">
                        <div class="row" >
                            <img src="../assets/img/contactUs/ico-user.png" alt="" class="ico1">
                            <span class="infotext1">&nbsp; 梁经理：</span>
                            <span class="infotext3">&nbsp;1560 025 0681</span>
                        </div>
                        <div class="row" >
                            <img src="../assets/img/contactUs/ico-user.png" alt="" class="ico1">
                            <span class="infotext1">&nbsp; 乔经理：</span>
                            <span class="infotext3">&nbsp;1993 067 2457</span>
                        </div>
                     
                    </div> -->
                    <div style="display: flex;justify-content: space-between">
                        <div class="row" >
                           <img src="../assets/img/contactUs/ico-user.png" alt="" class="ico1">
                            <span class="infotext1">&nbsp; 许经理：</span>
                            <span class="infotext3">&nbsp;1590 126 5905</span>
                        </div>
                     
                    </div>
                       
                      </div>
                    </div>

                </div>
            </div>
        </div>










    </div>


</template>

<script lang='ts' setup>
import { reactive, toRefs, ref,onMounted } from 'vue'



onMounted(()=>{
    window._czc.push(['_trackEvent', '联系我们', '联系我们', '查看客服与技术咨询电话' ])
})





</script>
<style lang="scss" scoped>
.banner {
    width: 100%;
    height: 577px;
    position: relative;
    background: url('../assets/img/banner2/10-1.png') no-repeat center center;
    background-size: cover;

    .textbox {
        width: 1200px;
        height: 120px;
        position: absolute;
        top: 310px;
        left: 50%;
        transform: translate(-50%);
    }

    .banner-text1 {
        color: var(--Color-Neutral-neutral-11, #323335);
        
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 70px;
        text-align: left
    }

    .banner-text2 {
        color: var(--Color-Neutral-neutral-10, #64666B);
        text-align: center;
        
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        text-align: left
    }


}

.box1 {
    background: #fff;
    width: 100%;
    height: 536px;
    padding: 1px 0 0 0;

    .title {
        width: 420px;
        height: 34px;
        margin: 0 auto;
        background: url('../assets/img/contactUs/title-1.png') no-repeat center center;
        background-size: contain;
        margin-top: 88px;
    }

    .content {
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        margin-top: 64px;
        .infocard {
            width: 48%;
            height: 184px;
            border-radius: 8px;

            .top {
                height: 72px;
                width: 100%;
                background: url('../assets/img/contactUs/top1.jpg') no-repeat center center;
                background-size: 100% 100%;
                border-top-left-radius: var(--Radius-Border-radius-4, 8px);
                border-top-right-radius: var(--Radius-Border-radius-4, 8px);
            }

            .top2 {
                height: 72px;
                width: 100%;
                background: url('../assets/img/contactUs/top2.jpg') no-repeat center center;
                background-size: 100% 100%;
                border-top-left-radius: var(--Radius-Border-radius-4, 8px);
                border-top-right-radius: var(--Radius-Border-radius-4, 8px);

            }

            .top-text {
                color: var(--www-lightspotx-com-nero, #FFF);
                
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 72px;
                margin-left: 32px;
            }

            .infobox {
                background: rgb(247, 248, 250);
                width: 100%;
                height: 112px;
                // line-height: 112px;
                padding: 32px;
                padding-top: 40px;
                box-sizing: border-box;
                border-bottom-left-radius:var(--Radius-Border-radius-4, 8px);
                border-bottom-right-radius:var(--Radius-Border-radius-4, 8px);

            }

            .infotext1 {
                color: var(--Color-Neutral-neutral-10, #64666B);
                
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 30px;
            }

            .infotext2 {
                color: var(--Color-Neutral-neutral-11, #323335);
                
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 30px;
            }

            .infotext3 {
                color: var(--www-lightspotx-com-shark, #23252B);
                
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 30px;
            }
            .row{
                display: flex;
                align-items: center;
                height: 30px
            }
        }

    }


}
.ico1{
    width: 20px;height: 20px;margin-top: 0px
}
.ico2{
    width: 20px;height: 20px;margin-top: -10px
}
</style>